// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e7a98715","96":"446255c2","102":"593e15ac","160":"76b440f8","736":"89cb287b","770":"8aacfd4c","863":"9b90a739","873":"94935f70"}[chunkId] + ".chunk.js";
};